import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import Error404Component from './error-404.component';

let Error404Module = angular
  .module('Error404', [
    uiRouter
  ])
  .component('error404', Error404Component)
   .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('error404', {
      url: '/404',
      views: {
        'menu': "",
        'content': {
          component: 'error404'
        }
      }
    });
  })
  .name;

export default Error404Module;



// WEBPACK FOOTER //
// ./src/app/pages/error-404/error-404.module.js